"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApmLayout;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactZoomPanPinch = require("react-zoom-pan-pinch");
var _utils = require("../../utils");
var _excluded = ["width", "style"];
var _FormattedMessage, _FormattedMessage2, _FormattedMessage3, _RemoveIcon, _AddIcon;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    allocated: {
      backgroundColor: 'rgb(189,137,255) !important'
    },
    colorDiv: {
      bottom: 0,
      content: '""',
      position: 'absolute',
      top: 0,
      transition: [theme.transitions.create('right', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      }), theme.transitions.create('left', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      })].join(',')
    },
    console: {
      backgroundColor: theme.palette.grey[300],
      zIndex: 50
    },
    disabled: {
      backgroundImage: 'repeating-linear-gradient(-55deg, transparent, transparent 10px, ' + 'rgba(151, 151, 151, 0.5) 10px, rgba(151, 151, 151, 0.5) 11px)'
    },
    disabledZone: {
      '&:active': {
        pointerEvents: 'none'
      },
      '&:hover': {
        backgroundColor: theme.palette.background.default,
        zIndex: 41
      },
      zIndex: 40
    },
    errorIconContainer: {
      bottom: '0',
      height: '1.5em',
      left: '0',
      margin: '0.2em',
      position: 'absolute',
      width: '1.5em'
    },
    filled: {
      backgroundColor: '#82C086 !important'
    },
    hasError: {
      backgroundColor: 'rgb(229, 115, 115) !important'
    },
    keepOpen: {
      backgroundColor: 'rgba(255, 152, 0, 1) !important'
    },
    layout: {
      display: 'inline-block',
      margin: 'auto',
      padding: '1px 4px',
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    layoutAndLegendContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowX: 'hidden',
      transition: theme.transitions.create('margin', {
        duration: theme.transitions.duration.enteringScreen,
        easing: theme.transitions.easing.easeOut
      }),
      width: '100%'
    },
    layoutAndLegendContainerShift: {
      marginLeft: 0
    },
    layoutContainer: {
      overflowX: 'auto',
      overflowY: 'hidden',
      textAlign: 'center',
      width: '100%'
    },
    layoutLegend: {
      backgroundColor: theme.palette.background.default,
      borderRadius: 4,
      textAlign: 'center'
    },
    layoutLegendItem: {
      '& span': {
        marginLeft: 4
      },
      alignItems: 'center',
      display: 'inline-flex',
      margin: '12px 5px'
    },
    layoutLegendSymbol: {
      border: 'solid 1px #979797',
      height: 16,
      position: 'relative',
      width: 16
    },
    layoutLoading: {
      '&:after': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        content: '""',
        height: '100%',
        left: 0,
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: 100
      }
    },
    opened: {
      backgroundColor: 'rgb(255, 215, 0) !important'
    },
    partiallyFilled: {
      backgroundImage: 'linear-gradient(to right bottom, transparent 50%, #82C086 50%)'
    },
    partiallyFilledDisabled: {
      '&:before': {
        backgroundColor: 'transparent !important',
        backgroundImage: 'repeating-linear-gradient(-55deg, transparent, transparent 10px, ' + 'rgba(151, 151, 151, 0.5) 10px, rgba(151, 151, 151, 0.5) 11px)',
        opacity: '1 !important'
      },
      backgroundImage: 'linear-gradient(to right bottom, transparent 50%, #82C086 50%)'
    },
    selected: {
      '&:after': {
        opacity: "0.5 !important"
      }
    },
    selectTower: {
      left: 0,
      position: 'absolute',
      textTransform: 'none',
      top: -37,
      width: '100%'
    },
    selectTowerBottom: {
      bottom: -37,
      top: 'unset'
    },
    sensor: {
      '& p': {
        margin: 0
      },
      '& span': {
        fontSize: 14,
        lineHeight: theme.spacing(2)
      },
      '&$sensorbottom': {
        bottom: theme.spacing(1.5),
        top: 'auto'
      },
      '&$sensorerror': {
        backgroundColor: theme.palette.error.main
      },
      '&$sensormiddle': {
        top: '50%',
        transform: 'translate3d(-50%, -50%, 0)'
      },
      '&$sensoroutside_top_console': {
        top: theme.spacing(1.5)
      },
      '&$sensortop': {
        top: theme.spacing(1.5)
      },
      backgroundColor: theme.palette.primary.main,
      borderRadius: '50%',
      color: '#fff',
      fontSize: 10,
      height: theme.spacing(6),
      left: '50%',
      lineHeight: theme.spacing(1.5),
      padding: theme.spacing(1.5, 0),
      pointerEvents: 'none',
      position: 'absolute',
      textAlign: 'center',
      top: theme.spacing(1.5),
      transform: 'translateX(-50%)',
      width: theme.spacing(6),
      zIndex: 99
    },
    sensorbottom: {},
    sensorerror: {},
    sensormiddle: {},
    sensoroutside_top_console: {},
    sensortop: {},
    separator: {
      height: 1,
      width: '100%'
    },
    slot: {
      '&:after': {
        backgroundColor: theme.palette.primary.main,
        bottom: 0,
        content: '""',
        left: 0,
        opacity: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeInOut
        }),
        zIndex: 60
      },
      '&:before': {
        backgroundColor: theme.palette.action.hover,
        bottom: 0,
        content: '""',
        left: 0,
        opacity: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeInOut
        }),
        zIndex: 60
      },
      '&:hover': {
        backgroundColor: '#e2e2e2'
      },
      '&:hover:before': {
        opacity: 1
      },
      backgroundColor: theme.palette.background.paper,
      borderRadius: 0,
      display: 'block',
      fontWeight: 'initial',
      margin: 0,
      padding: 0,
      textTransform: 'none',
      zIndex: 60
    },
    slotId: {
      borderRadius: 4,
      color: theme.palette.text.primary,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '12px',
      minWidth: 16,
      padding: '0 4px',
      position: 'absolute',
      textAlign: 'center',
      textShadow: "0 0 4px ".concat(theme.palette.background.paper),
      top: 1,
      zIndex: 62
    },
    slotSize: {
      borderRadius: 4,
      color: theme.palette.text.primary,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '12px',
      minWidth: 16,
      overflow: 'hidden',
      padding: '0 4px',
      position: 'absolute',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      textShadow: "0 0 4px ".concat(theme.palette.background.paper),
      top: 16,
      whiteSpace: 'nowrap',
      zIndex: 62
    },
    slotSizeInline: {
      right: 0,
      top: 1
    },
    suspicious: {
      backgroundColor: 'rgba(230, 154, 154, 0.8) !important'
    },
    tower: {
      '&:after': {
        backgroundColor: theme.palette.success.light,
        bottom: 0,
        content: '""',
        left: 0,
        opacity: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
          easing: theme.transitions.easing.easeInOut
        }),
        zIndex: 59
      },
      backgroundColor: theme.palette.background.default,
      border: 'solid 1px #979797',
      display: 'inline-block',
      marginLeft: 0,
      marginTop: 37,
      position: 'relative',
      verticalAlign: 'top',
      width: 100,
      zIndex: 61
    },
    towerChild: {
      left: -1,
      position: 'absolute',
      width: 100
    },
    towerHeadingBottom: {
      marginBottom: 37
    },
    transformComponent: {
      display: 'inline-block'
    },
    withoutCrate: {
      backgroundColor: theme.palette.background.default
    },
    zoomButton: {
      margin: '0px 2px',
      padding: 2
    },
    zoomContainer: {
      alignItems: 'center',
      alignSelf: 'flex-end',
      backgroundColor: theme.palette.background.default,
      borderRadius: 4,
      display: 'flex',
      height: 40,
      justifyContent: 'center',
      marginTop: theme.spacing(2),
      padding: theme.spacing(1),
      textAlign: 'center',
      width: 120
    },
    zoomValue: {
      fontSize: 14,
      fontWeight: 500,
      width: 35
    }
  };
});
function toScale(x, scale) {
  return x / scale;
}
function getSlotStyles(_ref) {
  var apmType = _ref.apmType,
    displayHeight = _ref.displayHeight,
    displayWidth = _ref.displayWidth,
    left = _ref.left,
    scale = _ref.scale,
    top = _ref.top,
    nextSlot = _ref.nextSlot;
  var overLapingTopBorder = (0, _utils.isRobot)(apmType) // Trays are aligned from top
  ? (nextSlot == null ? void 0 : nextSlot.top) === top - displayHeight : (nextSlot == null ? void 0 : nextSlot.top) === top + displayHeight;
  var scaledHeight = toScale(displayHeight, scale);
  var scaledTop = toScale(top, scale);
  return (0, _extends2.default)({
    left: (0, _utils.hasValue)(left) ? toScale(left, scale) : -1,
    maxHeight: !overLapingTopBorder ? scaledHeight + 1 : scaledHeight,
    // if there's a overlaping top border, then
    minHeight: !overLapingTopBorder ? scaledHeight + 1 : scaledHeight,
    // we need to make slot bigger as next slot border is used for slot border
    top: !overLapingTopBorder ? scaledTop - 1 : scaledTop
  }, !!displayWidth && {
    maxWidth: toScale(displayWidth, scale),
    minWidth: toScale(displayWidth, scale)
  }, (0, _utils.isRobot)(apmType) && {
    border: 'solid 1px #979797'
  }, (0, _utils.isLocker)(apmType) && {
    borderBottom: 'solid 1px #979797',
    borderRight: 'solid 1px #979797',
    borderTop: 'solid 1px #979797'
  }, overLapingTopBorder && {
    borderTop: 'unset'
  });
}
function ApmLayout(_ref2) {
  var apmType = _ref2.apmType,
    _ref2$classes = _ref2.classes,
    addonClasses = _ref2$classes === void 0 ? {} : _ref2$classes,
    errors = _ref2.errors,
    id = _ref2.id,
    isLoading = _ref2.isLoading,
    _ref2$onSelectTowerSl = _ref2.onSelectTowerSlots,
    onSelectTowerSlots = _ref2$onSelectTowerSl === void 0 ? function () {} : _ref2$onSelectTowerSl,
    _ref2$onSlotClick = _ref2.onSlotClick,
    onSlotClick = _ref2$onSlotClick === void 0 ? function () {} : _ref2$onSlotClick,
    organizedSlots = _ref2.organizedSlots,
    persistentErrors = _ref2.persistentErrors,
    _ref2$scale = _ref2.scale,
    scale = _ref2$scale === void 0 ? 3.65 : _ref2$scale,
    selectedSlots = _ref2.selectedSlots,
    selectedTowers = _ref2.selectedTowers,
    showTemperatures = _ref2.showTemperatures,
    _ref2$showHumidities = _ref2.showHumidities,
    showHumidities = _ref2$showHumidities === void 0 ? false : _ref2$showHumidities,
    _ref2$showTwoSides = _ref2.showTwoSides,
    showTwoSides = _ref2$showTwoSides === void 0 ? false : _ref2$showTwoSides,
    _ref2$showSlotType = _ref2.showSlotType,
    showSlotType = _ref2$showSlotType === void 0 ? false : _ref2$showSlotType,
    _ref2$slots = _ref2.slots,
    slots = _ref2$slots === void 0 ? [] : _ref2$slots,
    _ref2$zoom = _ref2.zoom,
    zoom = _ref2$zoom === void 0 ? {} : _ref2$zoom,
    _ref2$towers = _ref2.towers,
    towers = _ref2$towers === void 0 ? [] : _ref2$towers;
  var baseClasses = useStyles();
  var classes = (0, _mapValues.default)(baseClasses, function (baseClass, key) {
    return (0, _classnames.default)(baseClass, addonClasses[key]);
  });
  var layoutContainerRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    layoutScrollPosition = _useState2[0],
    setLayoutScrollPosition = _useState2[1];
  (0, _react.useEffect)(function () {
    if (layoutContainerRef.current && (layoutContainerRef.current.scrollTop !== layoutScrollPosition.y || layoutContainerRef.current.scrollLeft !== layoutScrollPosition.x)) {
      layoutContainerRef.current.scrollTop = layoutScrollPosition.y;
      layoutContainerRef.current.scrollLeft = layoutScrollPosition.x;
    }
  }, [towers, layoutScrollPosition]);
  var scrollTimeoutFunc;
  var setLayoutScrollPositionFunction = function setLayoutScrollPositionFunction() {
    return setLayoutScrollPosition({
      x: layoutContainerRef.current.scrollLeft,
      y: layoutContainerRef.current.scrollTop
    });
  };
  var handleScroll = function handleScroll() {
    clearTimeout(scrollTimeoutFunc);
    if (layoutContainerRef.current && towers.length) {
      scrollTimeoutFunc = setTimeout(setLayoutScrollPositionFunction, 200);
    }
  };
  var _Array$fill = Array(9).fill(0),
    _Array$fill2 = (0, _slicedToArray2.default)(_Array$fill, 9),
    allocated = _Array$fill2[0],
    disabled = _Array$fill2[1],
    empty = _Array$fill2[2],
    filled = _Array$fill2[3],
    partiallyFilled = _Array$fill2[4],
    opened = _Array$fill2[5],
    withoutCrate = _Array$fill2[6],
    suspicious = _Array$fill2[7],
    keptOpen = _Array$fill2[8];
  slots.forEach(function (item) {
    if (item.filled) {
      filled += 1;
    } else {
      empty += 1;
    }
    if (item.partiallyFilled) {
      partiallyFilled += 1;
    }
    if (item.withoutCrate) {
      withoutCrate += 1;
    }
    if (item.allocation) {
      allocated += 1;
    }
    if (item.disabled || item.stateId === 1) {
      disabled += 1;
    }
    if (item.open) {
      opened += 1;
    }
    if (item.suspicious) {
      suspicious += 1;
    }
    if (item.keepOpen) {
      keptOpen += 1;
    }
  });
  var Slot = function Slot(_ref3) {
    var _Object$values, _Object$values$filter;
    var autoWidth = _ref3.autoWidth,
      slot = _ref3.slot,
      slotIndex = _ref3.slotIndex,
      towerIndex = _ref3.towerIndex,
      nextSlot = _ref3.nextSlot;
    var allocation = slot.allocation,
      slotDisabled = slot.disabled,
      displayHeight = slot.displayHeight,
      displayWidth = slot.displayWidth,
      slotFilled = slot.filled,
      left = slot.left,
      open = slot.open,
      slotPartiallyFilled = slot.partiallyFilled,
      keepOpen = slot.keepOpen,
      slotId = slot.slotId,
      slotTitle = slot.slotTitle,
      stateId = slot.stateId,
      top = slot.top,
      type = slot.type,
      slotWithoutCrate = slot.withoutCrate,
      suspiciousSlots = slot.suspicious;
    var showOpen = !organizedSlots && open;
    var showDisabled = !organizedSlots && (stateId === 1 || slotDisabled);
    var showPartallyFilled = !showOpen && partiallyFilled && !organizedSlots && slotPartiallyFilled;
    var classesNames = (0, _classnames.default)(classes.towerChild, classes.slot, {
      [classes.allocated]: allocated && !organizedSlots && allocation,
      [classes.disabled]: showDisabled,
      [classes.opened]: !keepOpen && showOpen,
      [classes.filled]: !organizedSlots && slotFilled,
      [classes.partiallyFilled]: showPartallyFilled,
      [classes.partiallyFilledDisabled]: !organizedSlots && showPartallyFilled && showDisabled,
      [classes.hasError]: errors == null ? void 0 : errors.includes(slotId),
      [classes.withoutCrate]: !organizedSlots && slotWithoutCrate,
      [classes.selected]: selectedSlots == null ? void 0 : selectedSlots.find(function (sId) {
        return sId === slotId;
      }),
      [classes.suspicious]: suspicious && suspiciousSlots && !(0, _utils.isLocker)(apmType),
      [classes.keepOpen]: keepOpen
    });
    var colorDivs;
    var slotColors = (_Object$values = Object.values(organizedSlots || {})) == null ? void 0 : (_Object$values$filter = _Object$values.filter(function (_ref4) {
      var color = _ref4.color,
        slotIds = _ref4.slotIds,
        hidden = _ref4.hidden;
      return (slotIds == null ? void 0 : slotIds.includes(slotId)) && color && !hidden;
    })) == null ? void 0 : _Object$values$filter.map(function (_ref5) {
      var color = _ref5.color;
      return color;
    });
    if (slotColors != null && slotColors.length) {
      var colorsLength = slotColors.length;
      var colorLength = 100 / colorsLength;
      colorDivs = slotColors.map(function (color, index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: color,
          className: classes.colorDiv,
          style: {
            backgroundColor: (0, _utils.hexAToRGBA)(color, 0.6),
            border: "1px solid ".concat(color),
            left: "".concat(index * colorLength, "%"),
            right: "".concat((colorsLength - index - 1) * colorLength, "%")
          }
        });
      });
    }
    var slotStyles = getSlotStyles({
      apmType,
      displayHeight,
      displayWidth: autoWidth ? undefined : displayWidth,
      left,
      nextSlot,
      scale,
      top
    });
    var showSlotTitleInline = slotStyles.maxHeight < 24;
    var SlotWidth = toScale(autoWidth ? 100 : displayWidth, scale);
    return /*#__PURE__*/_react.default.createElement(_material.Button, {
      key: slotId,
      className: classesNames,
      id: "".concat(id, "Towers").concat(towerIndex, "Slots").concat(slotIndex, "SelectButton"),
      onClick: function onClick() {
        return onSlotClick(slotId);
      },
      style: slotStyles
    }, colorDivs, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.slotId,
      id: "".concat(id, "Towers").concat(towerIndex, "Slots").concat(slotIndex, "Id"),
      variant: "body2"
    }, slotId), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.slotSize, {
        [classes.slotSizeInline]: showSlotTitleInline
      }),
      id: "".concat(id, "Towers").concat(towerIndex, "Slots").concat(slotIndex, "Title"),
      style: {
        maxWidth: showSlotTitleInline ? SlotWidth * 0.7 : SlotWidth
      },
      variant: "body2"
    }, slotTitle), showSlotType && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      title: type
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.slotSize, {
        [classes.slotSizeInline]: showSlotTitleInline
      }),
      id: "".concat(id, "Towers").concat(towerIndex, "Slots").concat(slotIndex, "Type"),
      style: {
        marginRight: '32px',
        maxWidth: SlotWidth,
        top: showSlotTitleInline ? null : '32px'
      },
      variant: "body2"
    }, type)), (persistentErrors == null ? void 0 : persistentErrors.includes(slotId)) && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.errorIconContainer
    }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.ErrorOutline, {
      color: "error",
      style: {
        height: '100%',
        width: '100%'
      }
    })));
  };
  var Console = function Console(_ref6) {
    var autoWidth = _ref6.autoWidth,
      slot = _ref6.slot,
      consoleIndex = _ref6.consoleIndex,
      towerIndex = _ref6.towerIndex;
    var displayHeight = slot.displayHeight,
      displayWidth = slot.displayWidth,
      left = slot.left,
      open = slot.open,
      top = slot.top;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(classes.towerChild, classes.console, {
        [classes.open]: open
      }),
      id: "".concat(id, "Towers").concat(towerIndex, "Consoles").concat(consoleIndex),
      style: getSlotStyles({
        apmType,
        displayHeight,
        displayWidth: autoWidth ? undefined : displayWidth,
        left,
        scale,
        top
      })
    }, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "apmLayout.console"
    })));
  };
  var DisabledZone = function DisabledZone(_ref7) {
    var zone = _ref7.zone,
      zoneIndex = _ref7.zoneIndex,
      towerIndex = _ref7.towerIndex;
    var zoneId = zone.zoneId,
      displayHeight = zone.displayHeight,
      top = zone.top;
    var classesNames = (0, _classnames.default)(classes.towerChild, classes.disabledZone, classes.disabled);
    return /*#__PURE__*/_react.default.createElement("div", {
      key: zoneId,
      className: classesNames,
      id: "".concat(id, "Towers").concat(towerIndex, "DisabledZones").concat(zoneIndex),
      style: getSlotStyles({
        apmType,
        displayHeight,
        scale,
        top
      })
    });
  };
  var Sensor = function Sensor(_ref8) {
    var hasError = _ref8.hasError,
      index = _ref8.index,
      location = _ref8.location,
      value = _ref8.value;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(classes.sensor, classes["sensor".concat(location)], {
        [classes.sensorerror]: hasError
      })
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, index.startsWith('T') ? "".concat(value, "\xB0") : value)), /*#__PURE__*/_react.default.createElement("p", null, index));
  };
  var Towers = function Towers(_ref9) {
    var side = _ref9.side,
      sideTowers = _ref9.sideTowers;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(classes.layout, {
        [classes.layoutLoading]: isLoading,
        [classes.towerHeadingBottom]: (0, _utils.isDoubleSidedBackSide)(side)
      }),
      id: "".concat(id, "Towers")
    }, sideTowers.map(function (_ref10, towerIndex) {
      var consoles = _ref10.consoles,
        disabledZones = _ref10.disabledZones,
        displayHeight = _ref10.displayHeight,
        displayWidth = _ref10.displayWidth,
        gaps = _ref10.gaps,
        tId = _ref10.id,
        _ref10$sensors = _ref10.sensors,
        sensors = _ref10$sensors === void 0 ? [] : _ref10$sensors,
        tSlots = _ref10.slots,
        title = _ref10.title,
        verticalAlign = _ref10.verticalAlign;
      var renderGap = function renderGap(_ref11) {
        var width = _ref11.width,
          style = _ref11.style,
          props = (0, _objectWithoutProperties2.default)(_ref11, _excluded);
        return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          className: classes.tower,
          style: (0, _extends2.default)({
            maxWidth: toScale(width, scale),
            minHeight: toScale(displayHeight, scale) + 1,
            minWidth: toScale(width, scale)
          }, (0, _utils.isRobot)(apmType) && {
            marginLeft: -1
          }, verticalAlign && {
            verticalAlign
          }, style)
        }, props));
      };
      var sensorsToShow = [];
      if (showTemperatures) {
        sensorsToShow.push.apply(sensorsToShow, (0, _toConsumableArray2.default)(sensors.filter(function (sensor) {
          return sensor.index.startsWith('T');
        })));
      }
      if (showHumidities) {
        sensorsToShow.push.apply(sensorsToShow, (0, _toConsumableArray2.default)(sensors.filter(function (sensor) {
          return sensor.index.startsWith('H');
        })));
      }
      var classesNames = (0, _classnames.default)(classes.tower, {
        [classes.selected]: selectedTowers == null ? void 0 : selectedTowers.find(function (sId) {
          return sId === tId;
        })
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: title
      }, (gaps == null ? void 0 : gaps.left) > 0 && renderGap({
        id: "".concat(id, "Towers").concat(towerIndex, "LeftGap"),
        style: {
          borderRight: 'none'
        },
        width: gaps.left
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: classesNames,
        id: "".concat(id, "Towers").concat(towerIndex, "Title"),
        style: (0, _extends2.default)({
          minHeight: toScale(displayHeight, scale) + 1
        }, (0, _utils.hasValue)(displayWidth) && {
          maxWidth: toScale(displayWidth, scale),
          minWidth: toScale(displayWidth, scale)
        }, (0, _utils.isRobot)(apmType) && {
          marginLeft: -1
        }, verticalAlign && {
          verticalAlign
        })
      }, /*#__PURE__*/_react.default.createElement(_material.Button, {
        className: (0, _classnames.default)(classes.selectTower, {
          [classes.selectTowerBottom]: (0, _utils.isDoubleSidedBackSide)(side)
        }),
        color: "primary",
        id: "".concat(id, "Towers").concat(towerIndex, "SelectSlotsButton"),
        onClick: function onClick() {
          return onSelectTowerSlots(tSlots.map(function (_ref12) {
            var slotId = _ref12.slotId;
            return slotId;
          }), side, tId);
        }
      }, title), disabledZones && disabledZones.map(function (zone, zoneIndex) {
        return /*#__PURE__*/_react.default.createElement(DisabledZone, {
          key: zone.zoneId,
          towerIndex: towerIndex,
          zone: zone,
          zoneIndex: zoneIndex
        });
      }), consoles && consoles.map(function (slot, consoleIndex) {
        return /*#__PURE__*/_react.default.createElement(Console, {
          key: "console",
          autoWidth: !(0, _utils.hasValue)(displayWidth),
          consoleIndex: consoleIndex,
          slot: slot,
          towerIndex: towerIndex
        });
      }), tSlots.map(function (slot, slotIndex) {
        return /*#__PURE__*/_react.default.createElement(Slot, {
          key: slot.slotId,
          autoWidth: !(0, _utils.hasValue)(displayWidth),
          nextSlot: tSlots[slotIndex + 1],
          slot: slot,
          slotIndex: slotIndex,
          towerIndex: towerIndex
        });
      }), sensorsToShow.map(function (sensor) {
        return /*#__PURE__*/_react.default.createElement(Sensor, (0, _extends2.default)({
          key: sensor.index
        }, sensor));
      })), (gaps == null ? void 0 : gaps.right) > 0 && renderGap((0, _extends2.default)({
        id: "".concat(id, "Towers").concat(towerIndex, "RightGap"),
        width: gaps.right
      }, towerIndex !== sideTowers.length - 1 && {
        style: {
          borderRight: 'none'
        }
      })));
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.layoutAndLegendContainer, classes.root, {
      [classes.layoutAndLegendContainerShift]: organizedSlots
    })
  }, !organizedSlots && towers.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.layoutLegend
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "FilledCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.filled)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "FilledCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.filled",
    values: {
      count: filled
    }
  }))), !!partiallyFilled && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "PartiallyFilledCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.partiallyFilled)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "PartiallyFilledtValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.partiallyFilled",
    values: {
      count: partiallyFilled
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "EmptyCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.empty)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "EmptyCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.empty",
    values: {
      count: empty
    }
  }))), (0, _utils.is501)(apmType) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "WithoutCreateCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.withoutCrate)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "WithoutCreateCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.withoutCrate",
    values: {
      count: withoutCrate
    }
  }))), errors && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "HasError"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.hasError)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "HasErrorCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.hasError",
    values: {
      count: errors.length
    }
  }))), persistentErrors && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "HasPersistentError"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_iconsMaterial.ErrorOutline, {
    color: "error",
    style: {
      height: '16px',
      width: '16px'
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "HasPersistentErrorCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.hasPersistentError",
    values: {
      count: persistentErrors.length
    }
  })))), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "DisabledCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.disabled)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "DisabledCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.disabled",
    values: {
      count: disabled
    }
  }))), (0, _utils.isLocker)(apmType) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "OpenedCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.opened)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "OpenedCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.opened",
    values: {
      count: opened
    }
  }))), !!allocated && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "AllocatedCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.allocated)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "AllocatedCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.allocated",
    values: {
      count: allocated
    }
  }))), !!keptOpen && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "KeptOpenCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.keepOpen)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "KeptOpenCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.keptOpen",
    values: {
      count: keptOpen
    }
  }))), selectedSlots && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "SelectedSlotsCount"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.selected)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "SelectedSlotsCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.selectedSlots",
    values: {
      count: selectedSlots.length
    }
  }))), !!suspicious && !(0, _utils.isLocker)(apmType) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "suspiciousSlots"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)(classes.slot, classes.layoutLegendSymbol, classes.suspicious)
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(id, "suspiciousSlotsCountValue")
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.suspiciousSlots",
    values: {
      count: suspicious
    }
  }))), (0, _utils.is501)(apmType) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "TemperatureZoneLT"),
    variant: "body2"
  }, _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.lowTemperature"
  }))), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.layoutLegendItem,
    id: "".concat(id, "TemperatureZoneMT"),
    variant: "body2"
  }, _FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "apmLayout.mediumTemperature"
  }))))), /*#__PURE__*/_react.default.createElement(_reactZoomPanPinch.TransformWrapper, (0, _utils.mergeDeep)({
    disabled: !(zoom != null && zoom.enabled),
    doubleClick: {
      disabled: true
    },
    initialScale: 1,
    maxScale: 1,
    minScale: 0.5,
    panning: {
      disabled: true
    },
    wheel: {
      disabled: true
    }
  }, zoom), function (_ref13) {
    var state = _ref13.state,
      zoomIn = _ref13.zoomIn,
      zoomOut = _ref13.zoomOut;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      ref: layoutContainerRef,
      className: classes.layoutContainer,
      id: "".concat(id, "LayoutContainer"),
      onScroll: handleScroll
    }, /*#__PURE__*/_react.default.createElement(_reactZoomPanPinch.TransformComponent, {
      wrapperClass: classes.transformComponent
    }, /*#__PURE__*/_react.default.createElement(Towers, {
      side: (0, _utils.getDoubleSidedFrontSide)(),
      sideTowers: towers == null ? void 0 : towers.filter(function (_ref14) {
        var side = _ref14.side;
        return !showTwoSides ? true : (0, _utils.isDoubleSidedFrontSide)(side);
      })
    }), showTwoSides && (towers == null ? void 0 : towers.some(function (_ref15) {
      var side = _ref15.side;
      return (0, _utils.isDoubleSidedBackSide)(side);
    })) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.separator
    }), /*#__PURE__*/_react.default.createElement(Towers, {
      side: (0, _utils.getDoubleSidedBackSide)(),
      sideTowers: towers == null ? void 0 : towers.filter(function (_ref16) {
        var side = _ref16.side;
        return (0, _utils.isDoubleSidedBackSide)(side);
      })
    })))), !!(zoom != null && zoom.enabled && towers != null && towers.length) && /*#__PURE__*/_react.default.createElement("div", {
      className: classes.zoomContainer
    }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      className: classes.zoomButton,
      id: "".concat(id, "ZoomOutButton"),
      onClick: function onClick() {
        var _zoom$ZoomOut;
        return zoomOut(((_zoom$ZoomOut = zoom.ZoomOut) == null ? void 0 : _zoom$ZoomOut.step) || 0.25);
      },
      size: "large"
    }, _RemoveIcon || (_RemoveIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Remove, null))), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.zoomValue,
      id: "".concat(id, "ZoomValue")
    }, Math.round(state.scale * 100), "%"), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      className: classes.zoomButton,
      id: "".concat(id, "ZoomInButton"),
      onClick: function onClick() {
        var _zoom$ZoomIn;
        return zoomIn(((_zoom$ZoomIn = zoom.ZoomIn) == null ? void 0 : _zoom$ZoomIn.step) || 0.25);
      },
      size: "large"
    }, _AddIcon || (_AddIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Add, null)))));
  }));
}